/*global define*/
/*jshint devel:true*/
/**
 * Base service model
 */
define(
	'BaseServiceModel',[
		'BaseModel'
	],
	function (BaseModel) {
		'use strict';
		return BaseModel.extend({
			className: 'BaseServiceModel'
		});
	}
);
